<script>
import Vue from 'vue'
import SurveySlider from './SurveySlider.vue'

export default Vue.component('SurveyCategory', {
    functional: true,
    props: {
        questions: {
            type: Object,
            required: true,
        },
        survey: {
            type: Object,
            required: true,
        },
    },
    render(createElement, context) {
        let elements = []

        for (let [key, question] of Object.entries(context.props.questions)) {
            const value = context.props.survey[key] ?? { count: null, max: null, min: null, value: null }

            elements.push(
                createElement('div', { class: 'survey-question-container' }, [
                    createElement('span', { class: 'survey-question' }, question.display),
                    createElement('span', { class: 'survey-label-low' }, question.left),
                    createElement(SurveySlider, { props: value.hasOwnProperty('value') ? value : { value } }),
                    createElement('span', { class: 'survey-label-high' }, question.right),
                ])
            )
        }

        return createElement('div', { class: 'survey-category' }, elements)
    },
})
</script>
<style>
.survey-category {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .survey-question-container {
        display: grid;
        grid-template-columns: 144px 96px minmax(120px, 1fr) 96px;
        justify-items: center;
        align-items: center;

        .slider-label-static {
            display: none;
        }

        &:last-child .slider-label-static {
            display: initial;
        }
    }

    .survey-question {
        justify-self: end;
    }

    .survey-label-low {
        justify-self: end;
    }

    .survey-slider {
        width: 100%;
    }

    .survey-label-high {
        justify-self: start;
    }
}
</style>
